export default __webpack_public_path__ + "static/media/github.4513e8ed.png";